import { render, staticRenderFns } from "./SocialMediaListAll.vue?vue&type=template&id=6b891c4e&"
import script from "./SocialMediaListAll.vue?vue&type=script&lang=js&"
export * from "./SocialMediaListAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b891c4e')) {
      api.createRecord('6b891c4e', component.options)
    } else {
      api.reload('6b891c4e', component.options)
    }
    module.hot.accept("./SocialMediaListAll.vue?vue&type=template&id=6b891c4e&", function () {
      api.rerender('6b891c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialMediaListAll.vue"
export default component.exports